window.KP_MACHINE_CATALOG={
"power-pcb-manufacture-from-1802-240v":{c:"v",m:{ses875:">=1802"}},
"tube-for-valve-7-cm-ses810":{c:"v",m:{ses810:"1"}},
"valve-selector-ses876":{c:"v",m:{ses875:"1",ses876:"1"}},
"water-pump-ulka-eep5fm-sp-230v":{c:"v",m:{ses450:"1",ses500:"1",ses810:"1",ses870:"1",ses875:"1",ses876:"1",ses878:"1",ses880:"1",ses881:"1",ses920:"1",ses980:"1",ses990:"1"}},
"flow-meter":{c:"p",m:{ses450:"1",ses500:"1",ses810:"1",ses875:"1",ses876:"1",ses878:"1",ses880:"1",ses881:"1",ses920:"1",ses980:"1",ses990:"1"}},
"valve-solenoid-240v-v397":{c:"p",m:{ses875:"1",ses878:"1",ses880:"1"}},
"solenoid-valve-240v-ceme-v799":{c:"p",m:{ses875:"1",ses878:"1",ses880:"1",ses881:"1"}},
"valve-block-complete-240v-manufacture-from":{c:"v",m:{ses875:"1"}},
"duschkopf":{c:"v",m:{ses875:"1"}},
"grinder-assy":{c:"v",m:{ses878:"1"}},
"flow-meter-sp0011386-2":{c:"p",m:{ses875:"1",ses876:"1",ses878:"1",ses880:"1"}},
"motherboard":{c:"v",m:{ses880:"1"}},
"milk-sensor-ntc":{c:"p",m:{ses500:"1",ses880:"1"}},
"54mm-cleaning-disc-sp0001517-2":{c:"p",m:{ses875:"1",ses878:"1",ses880:"1"}},
"sieve-carrier-seal-54mm-sp0025526-2":{c:"p",m:{ses875:"1",ses878:"1",ses880:"1"}},
"duschsieb-54mm-sp0025527":{c:"p",m:{ses875:"1",ses878:"1",ses880:"1"}},
"grinder-with-seam-manufacture-from-1927":{c:"v",m:{ses880:">=1927"}},
"nozzle-dyse-steam-wand-steam-arm-assy":{c:"p",m:{ses880:"1",ses881:"1"}},
"valve-block-ceme-v393":{c:"v",m:{ses880:"1"}},
"turbine-compl-with-cable":{c:"v",m:{ses878:"1",ses880:"1"}},
"brewing-head-240v-from-pdc1522":{c:"v",m:{ses980:">=1522",ses990:">=1522"}},
"pcb-power-kit-240v":{c:"v",m:{ses980:"1"}},
"power-electronics-pcb-triac":{c:"v",m:{ses980:"1"}},
"descale-valve":{c:"p",m:{ses980:"1"}},
"air-pump-cjp30-c03b6":{c:"v",m:{ses980:"1"}},
"steam-tap-0-73mm":{c:"v",m:{ses980:"1"}},
"coffee-grinder-ses990":{c:"v",m:{ses980:"1"}},
"ntc-thermosensor-coffee-boiler-keddel-ses980-990":{c:"r",m:{}},
"probe-coffee-kit-set-2-240v-sp0001816":{c:"r",m:{}},
"ntc-for-showerhead":{c:"v",m:{ses990:"1"}},
"coffee-boiler-keddel-probe-set-ses920-980-990-from-sp0102125":{c:"r",m:{}},
"ntc-coffee-boiler-keddel-compression-sp0102131":{c:"r",m:{}},
"u-clip-for-coffee-probe-sp0001621":{c:"v",m:{ses920:"1",ses980:"1",ses990:"1"}},
"gasket-kit-for-solenoid-valve-sp0001810-sp0001810":{c:"p",m:{ses980:"1",ses990:"1"}},
"pcb-power-240v":{c:"p",m:{ses980:"1",ses990:"1"}},
"triac-pcb":{c:"v",m:{ses990:"1"}},
"crimp-connector-ce-5-for-4-wires-sp0024457-4":{c:"v",m:{ses875:"1",ses878:"1",ses880:"1",ses980:"1",ses990:"1"}},
"sieve-carrier-seal-58mm-sp0001635":{c:"p",m:{ses980:"1",ses990:"1"}},
"showerhead-58mm-ses900-sp0001641":{c:"v",m:{ses920:"1",ses980:"1",ses990:"1"}},
"inner-shower-strainer-58mm-from-1736-pdc-sp0023671":{c:"v",m:{ses920:">=1736",ses980:">=1736",ses990:">=1736"}},
"showerhead-screw-m5-x-17-sp0027819":{c:"p",m:{ses980:"1",ses990:"1"}},
"reinigungsscheibe-sp0001762":{c:"v",m:{ses920:"1",ses980:"1",ses990:"1"}},
"solenoid-valve-ceme-v799-sp0026682-2":{c:"p",m:{ses980:"1",ses990:"1"}},
"spring-lock-for-top-cover-ses900-sp0001607":{c:"p",m:{ses980:"1",ses990:"1"}},
"pressure-relief-valve-for-the-coffee-pump-sp0001676-2":{c:"r",m:{}},
"steam-pump-thermostat-sp0001825":{c:"v",m:{ses920:"1",ses980:"1",ses990:"1"}},
"hose-from-the-coffee-boiler-keddel-to-the-drain-valve-sp0001836":{c:"v",m:{ses980:"<=2228",ses990:"<=2242"}},
"coffee-boiler-keddel-drain-valve":{c:"v",m:{ses990:"1"}},
"flow-meter-sp0001666-3":{c:"v",m:{ses920:"1",ses980:"1",ses990:"1"}},
"steam-descaler-valve":{c:"v",m:{ses990:"1"}},
"o-ring-rot-sp0001672":{c:"p",m:{ses875:"1",ses920:"1",ses980:"1",ses990:"1"}},
"spacer-steam-wand-steam-arm-wht":{c:"p",m:{ses980:"1",ses990:"1"}},
"steam-tap-with-0-73mm-holes":{c:"v",m:{ses990:"1"}},
"venturi-kit-with-solenoid-valve-v399-sp0027746":{c:"p",m:{ses980:"1",ses990:"1"}},
"ntc-wire-for-steam-boiler-keddel-steam-keddel":{c:"p",m:{ses990:"<=2242"}},
"vacuum-valve-sp0001652":{c:"v",m:{ses980:"1",ses990:"1"}},
"steam-boiler-keddel-steam-keddel-probe-set-240v-sp0102121":{c:"v",m:{ses920:">=2233",ses980:">=2228",ses990:">=2242"}},
"ntc-steam-boiler-keddel-steam-keddel-compression-fitting-sp0102122":{c:"r",m:{}},
"seal-for-steam-probes-sp0001657":{c:"p",m:{ses920:"1",ses980:"1",ses990:"1"}},
"thermostat-steam-boiler-keddel-steam-keddel-sp0001659":{c:"v",m:{ses980:"1",ses990:"1"}},
"retaining-clip-for-teflon-hoses-large-sp0001673-3":{s:"u",c:"v"},
"retaining-clip-for-teflon-hoses-small-sp0001674":{s:"u",c:"v"},
"steam-probe-set-3-probes-with-seals-sp0001820":{c:"r",m:{}},
"steam-boiler-keddel-steam-keddel-kit-240v-from-1828-pdc":{c:"r",m:{}},
"steam-boiler-keddel-steam-keddel-fuse-kit":{c:"p",m:{ses990:"1"}},
"tamper-plate-58mm":{c:"v",m:{ses980:"1",ses990:"1"}},
"inner-burr-for-etzinger-burr-from-pdc1926-sp0027463-2":{c:"p",m:{ses875:">=1926",ses878:"1",ses880:"1",ses980:"1",ses990:"1"}},
"external-grindstone-ses875-sp0001801-3":{c:"r",m:{}},
"coffee-grinder-ver-b":{c:"p",m:{ses980:"1",ses990:"1"}},
"gear-main-grinder-from-pdc2309-sp0103055-4":{c:"p",m:{ses875:">=2024",ses878:">=2024",ses880:">=2024",ses980:">=2024",ses990:">=2024"}},
"water-outlet-holder-assembly-ses900-sp0001684":{c:"p",m:{ses980:"1",ses990:"1"}},
"elbow-fitting":{c:"p",m:{ses875:"1",ses920:"1",ses980:"1",ses990:"1"}},
"ulka-ex5-pumpe":{c:"p",m:{ses990:"1"}},
"3-vejs-magnetventil-240-v-sage-oracle-oracle-touch-sp0001810":{c:"p",m:{ses980:"1",ses990:"1"}},
"hovedgear-til-kvaern-sage-oracle-barista-sp0100119":{c:"p",m:{ses875:">=2024",ses878:">=2024",ses880:">=2024",ses980:">=2024",ses990:">=2024"}},
"thermostat-165-c-m4x6-manual-reset-9v074":{s:"o",c:"v"},
"kvaernknive-o64-mm-mazzer-super-jolly-fiorenzato-fc-m5-9m8k":{s:"o",c:"v"},
"faema-filterkurv-1-cup-7-g-h24-mm-aisi304":{s:"u",c:"v"},
"front-cover-til-vandstandsindikator-mat-sort-nuova-simonelli-aurelia-05000817-no":{s:"o",c:"v"},
"varmelegeme-1400-w-230-v-vbm-domobar-colged-ecm-giotto-8v605":{s:"o",c:"v"},
"tamper-58-mm-sort-lakeret-bogetrae-ergonomisk-handtag":{s:"u",c:"v"},
"tamper-58-mm-rod-lakeret-bogetrae-ergonomisk-handtag":{s:"u",c:"v"},
"tamper-58-mm-naturlig-bog-ergonomisk-handtag":{s:"u",c:"v"},
"bottomless-portafilter-la-marzocco-faema-brasilia-valnoddetraeshandtag":{s:"o",c:"v"},
"probe-genopbygningskit-sage-dual-boiler-oracle-oracle-touch":{c:"v",m:{ses920:"1",ses980:"1",ses990:"1"}},
"sage-barista-touch-varmelegeme":{c:"p",m:{ses878:"1",ses880:"1"}},
"thermoblock-kit-240v-til-sage-barista-express-express-impress-sp0101836":{c:"v",m:{ses875:"1",ses876:"1"}},
"triac-pcb-240v-til-sage-dual-boiler-ses920-sp0001772":{c:"v",m:{ses920:"1"}},
"ntc-temperatursensor-til-sage-oracle-ses980-sp0001650":{c:"v",m:{ses980:"<=2227"}},
"damp-magnetventil-v399-til-sage-dual-boiler-oracle-oracle-touch-sp0026954":{c:"v",m:{ses920:"1",ses980:"1",ses990:"1"}},
"ydre-kvaernsten-upper-burr-version-b-til-sage-barista-touch-oracle-touch-sp0001801":{c:"r",m:{}},
"filt-skive-felt-washer-til-kvaern-sage-sp0001575":{c:"p",m:{ses875:"1",ses876:"1",ses878:"1",ses880:"1",ses881:"1",ses920:"1",ses980:"1",ses990:"1"}},
"kolepasta-5g-til-triac-kort-elektronik-amasan-t12":{s:"u",c:"v"},
"steam-vibrationspumpe-48w-230v-til-sage-barista-oracle":{c:"p",m:{ses870:"1",ses875:"1",ses876:"1",ses878:"1",ses880:"1",ses881:"1",ses920:"1",ses980:"1",ses990:"1"}},
"urnex-cafiza-566g":{s:"u",c:"v"},
"fodevaregodkendt-silikonefedt-til-espressomaskiner-10gram":{s:"u",c:"v"},
"komplet-precision-burr-assembly-til-sage-barista-oracle-sp0110082":{c:"p",m:{ses878:"1",ses880:"1",ses881:"1",ses980:"1",ses990:"1"}}
};
